import { useCallback } from 'react'
import { replaceSearchString } from 'actions/NavigationActions'
import { CRUISE_BUNDLE_FILTER_QUERY_PARAM } from 'constants/cruise'
import { useAppDispatch } from 'hooks/reduxHooks'
import useQueryParams from 'hooks/useQueryParams'

export default function useCruiseBundleFilter() {
  const dispatch = useAppDispatch()
  const params = useQueryParams()
  const bundleFilterEnabled = params.get(CRUISE_BUNDLE_FILTER_QUERY_PARAM) === 'true'

  const setBundleFilterEnabled = useCallback((enabled: boolean) => {
    dispatch(replaceSearchString({ [CRUISE_BUNDLE_FILTER_QUERY_PARAM]: enabled ? 'true' : undefined }))
  }, [dispatch])

  return { bundleFilterEnabled, setBundleFilterEnabled }
}
